import { formatCPF, formatNUMBER } from '@format';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { excluirAlert } from 'app/services/alerts';
import pessoaApi from 'app/services/api/pessoaApi';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

const filter = createFilterOptions();

const confirmacaoEdicao = (confirmarFunc, cancelarFunc, papel, fetchPapel) => {
  excluirAlert({
    opcoes: {
      title: 'O CPF informado já está cadastrado. Deseja atualizá-lo?',
      text: '',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    },
    confirmar: async () => confirmarFunc(papel, fetchPapel),
    cancelar: async () => cancelarFunc(),
  });
};

const handleChange = (onChange, setInputValue, setShowAlert, setOptions, onSelect, papel, fetchPapel) => {
  return (event, newValue, reason) => {
    if (typeof newValue === 'string') {
      onChange({ target: { id: 'pessoa.pessoaFisica.cpf', value: formatNUMBER(newValue) } });
      setInputValue(newValue);
    } else if (newValue && newValue.inputValue) {
      onChange({ target: { id: 'pessoa.pessoaFisica.cpf', value: formatNUMBER(newValue.inputValue) } });
      setInputValue(newValue.inputValue);
    } else if (reason === 'clear') {
      onChange({ target: { id: 'pessoa.pessoaFisica.cpf', value: undefined } });
      onChange({ target: { id: 'pessoa.id', value: undefined } });
      onChange({ target: { id: 'pessoa.pessoaFisica.id', value: undefined } });
    } else {
      criarAlertaEdicaoPessoa(setShowAlert, setOptions, newValue, onChange, onSelect, setInputValue, papel, fetchPapel);
    }
  };
};

const handleInputChange = (onChange, setInputValue, setOptions, fetchData, options) => {
  return (event, value) => {
    const numberCPF = formatNUMBER(value);
    if (!numberCPF || numberCPF.length <= 11) {
      onChange({ target: { id: 'pessoa.pessoaFisica.cpf', value: numberCPF } });
      /**
       * Esse onChange abaixo é o responsavel por setar o dirty do formik como true, pois
       * está criando um atributo de pessoa que não existia no formulario
       *
       * onChange({ target: { id: 'pessoa.cpfCnpj', value: numberCPF } });
       */
      setInputValue(formatCPF(value));

      if (numberCPF >= 3 && !options.find((pessoa) => pessoa?.pessoaFisica?.cpf === numberCPF)) {
        (async () => {
          const response = await fetchData(numberCPF);

          setOptions(response.data);
        })();
      }
    }
  };
};

const handleBlur = (
  onBlur,
  options,
  setShowAlert,
  setOptions,
  onChange,
  setInputValue,
  onSelect,
  papel,
  fetchPapel
) => {
  return (event) => {
    const numberCPF = formatNUMBER(event.target.value);
    const newValue = options.find((pessoa) => pessoa?.cpfCnpj === numberCPF);

    if (numberCPF.length === 11 && newValue) {
      criarAlertaEdicaoPessoa(setShowAlert, setOptions, newValue, onChange, onSelect, setInputValue, papel, fetchPapel);
    }

    if (onBlur) {
      onBlur(event);
    }
  };
};

const handleOptionLabel = (option) => {
  // Value selected with enter, right from the input
  if (typeof option === 'string') {
    return formatCPF(option) || '';
  }
  // Add "xxx" option created dynamically
  if (option.inputValue) {
    return formatCPF(option.inputValue) || '';
  }
  // Regular option
  return formatCPF(option?.cpfCnpj) || formatCPF(option?.pessoaFisica?.cpf) || '';
};

const fetchData = pessoaApi.buscarPessoaFisica;

function criarAlertaEdicaoPessoa(
  setShowAlert,
  setOptions,
  newValue,
  onChange,
  onSelect,
  setInputValue,
  papel,
  fetchPapel
) {
  setShowAlert(true);
  const confirmar = async (papel, fetchPapel) => {
    setOptions([]);

    if (newValue.papeis?.includes(papel?.toUpperCase())) {
      fetchPapel(newValue[`${papel}Id`]);
      setShowAlert(false);
      return;
    }

    const response = await pessoaApi.buscarPessoaCompleta(newValue.id);

    const {
      data: { pessoa, ...papeis },
    } = response;

    if (pessoa?.pessoaFisica?.dataNascimento) {
      pessoa.pessoaFisica.dataNascimento = moment(pessoa.pessoaFisica.dataNascimento);
    }
    pessoa.cpfCnpj = pessoa?.pessoaFisica?.cpf;

    setShowAlert(false);

    onChange({ target: { id: 'id', value: papeis[`${papel}Id`] } });
    onChange({ target: { id: 'pessoa', value: { ...pessoa, tipoPessoa: 'FISICA' } } });
    onSelect();
  };
  const cancelar = () => {
    setOptions([]);
    setShowAlert(false);
    setInputValue(' ');

    onChange({ target: { id: 'pessoa.pessoaFisica.cpf', value: undefined } });
  };
  confirmacaoEdicao(confirmar, cancelar, papel, fetchPapel);
}

function PessoaFisicaAutocomplete({
  id = 'pessoa.pessoaFisica.cpf',
  name = 'pessoa.pessoaFisica.cpf',
  onChange,
  value,
  onSelect = () => {},
  error,
  touched,
  onBlur,
  disabled,
  papel,
  fetchPapel,
}) {
  // const [value, setValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (!showAlert) {
      if (inputValue && options && options.find((p) => p?.pessoaFisica?.cpf === formatNUMBER(inputValue))) {
        const pessoa = options.find((p) => p?.pessoaFisica?.cpf === formatNUMBER(inputValue));

        if (pessoa?.pessoaFisica?.dataNascimento) {
          pessoa.pessoaFisica.dataNascimento = moment(pessoa.pessoaFisica.dataNascimento);
        }

        onChange({ target: { id: 'pessoa', value: pessoa } });
      }
    }
    // Memoização intencional: as funções são recriadas a cada render e incluí-las anularia o memo;
    // o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue, showAlert]);

  return (
    <Autocomplete
      selectOnFocus
      freeSolo
      value={value}
      id={id}
      name={name}
      disabled={disabled}
      options={options}
      inputValue={inputValue}
      disableClearable={value?.id === undefined}
      onChange={handleChange(onChange, setInputValue, setShowAlert, setOptions, onSelect, papel, fetchPapel)}
      onInputChange={handleInputChange(onChange, setInputValue, setOptions, fetchData, options)}
      filterOptions={filter}
      getOptionLabel={handleOptionLabel}
      renderOption={(option) => formatCPF(option?.cpfCnpj) || formatCPF(option?.pessoaFisica?.cpf) || ''}
      getOptionSelected={(option, value) => {
        return option.id === value.id;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="CPF"
          variant="outlined"
          fullWidth
          InputLabelProps={{ shrink: true }}
          error={touched && error}
          helperText={touched && error}
          onBlur={handleBlur(
            onBlur,
            options,
            setShowAlert,
            setOptions,
            onChange,
            setInputValue,
            onSelect,
            papel,
            fetchPapel
          )}
        />
      )}
    />
  );
}

export default PessoaFisicaAutocomplete;
